module.exports = __webpack_public_path__ + "static/img/11.3a05dada.jpg";